import { getCurrentApiHost } from 'config/environment';
const parseHttpUrl = (raw)=>{
    try {
        const url = new URL(raw);
        return url.protocol === 'https:' || url.protocol === 'http:' ? url : null;
    } catch (unused) {
        return null;
    }
};
/**
 * Hosts we will attach the session api-key to. Must mirror BOTH derivations:
 *  - the frontend canonical API host (getCurrentApiHost — encodes special
 *    mappings for app.* and demo tenants), and
 *  - the backend's getBackendAPIDomain rule: insert `.api.` after the first
 *    DNS label of the current SPA host (what notification emails actually use).
 * Single-label hosts (localhost / ngrok dev) are accepted as-is.
 */ const trustedApiHosts = ()=>{
    var _parseHttpUrl;
    const hosts = new Set();
    const canonical = getCurrentApiHost();
    const canonicalHost = canonical ? (_parseHttpUrl = parseHttpUrl(canonical)) === null || _parseHttpUrl === void 0 ? void 0 : _parseHttpUrl.host : undefined;
    if (canonicalHost) {
        hosts.add(canonicalHost);
    }
    const { hostname } = window.location;
    const [firstLabel, ...rest] = hostname.split('.');
    hosts.add(rest.length ? `${firstLabel}.api.${rest.join('.')}` : hostname);
    return Array.from(hosts);
};
/** True only when `raw` targets THIS tenant's own API host family. */ export const isTrustedApiUrl = (raw)=>{
    const url = parseHttpUrl(raw);
    return !!url && trustedApiHosts().includes(url.host);
};
/** True only when `raw` targets the app's own (current window) origin. */ export const isSameAppOrigin = (raw)=>{
    const url = parseHttpUrl(raw);
    return !!url && url.origin === window.location.origin;
};
